import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import Typography from '@mui/material/Typography';
import { Controller } from 'react-hook-form';
import type { FormControlLabelProps } from '@mui/material/FormControlLabel';
import type { Control, FieldPath, FieldValues } from 'react-hook-form';
import { Box, FormControl, FormHelperText } from '@mui/material';
import IconNoCheck from 'src/assets/iconsSvg/uncheckCheckboxIcon';
import CheckedIconCheckBox from 'src/assets/iconsSvg/checkedIconCheckBox';
import { ReactNode } from 'react';

interface Props<T extends FieldValues> extends Omit<FormControlLabelProps, 'control' | 'label'> {
  control: Control<T>;
  name: FieldPath<T>;
  label: ReactNode;
  onChangeSelect?: (value: boolean) => void;
}

const ControllerCheckbox = <T extends FieldValues>(props: Props<T>) => {
  const { control, name, label, onChangeSelect, ...rest } = props;

  return (
    <Controller
      render={({ field, fieldState: { error } }) => (
        <FormControl error={Boolean(error)}>
          <FormControlLabel
            control={
              <Checkbox
                icon={<IconNoCheck disabled={rest.disabled}/>}
                checkedIcon={<CheckedIconCheckBox disabled={rest.disabled}/>}
                checked={field.value}
                onChange={(_, checked: any) => {
                  // if (onChangeSelect) {
                    onChangeSelect(checked)
                  // }
                }}
                />
            }
            label={<Box>{label}</Box>}
            {...rest}
            {...field}
          />
          {error?.message && (
            <FormHelperText variant="standard">{error.message}</FormHelperText>
          )}
        </FormControl>
      )}
      name={name}
      control={control}
    />
  );
};

export default ControllerCheckbox;
